"use client";

import { DirectusImage } from "@/components/DirectusImage";
import Title from "@/components/ui/title";
import { getDecimals } from "@/lib/utils";
import CountUp from "react-countup";

export default function ResearchInnovation2(props: {
  data?: {
    title?: string;
    description?: string;
    data_list?: {
      name?: string;
      value?: number;
      unit?: string;
      icon?: string;
    }[];
    image?: string;
    position?: "left" | "center" | "right";
  }
}) {
  return (
    <div className="reletive w-full min-h-[180px] md:min-h-[300px] lg:min-h-[400px] xl:min-h-[650px]">
      {props.data?.image && (
        <DirectusImage
          className="absolute z-[-1] h-full w-full object-cover"
          fill
          alt="backgroundImage"
          id={props.data?.image}
          style={{
            objectPosition: props.data?.position,
          }}
        />
      )}
      <div className="content_container flex-1 max-xl:px-6 pt-[34px] pb-[45px] md:pt-[64px] md:pb-[108px]">
        <div className="w-full">
          {props.data?.title && (
            <Title className="font-semibold" title={props.data?.title} underline={false} />
          )}
          {props.data?.description && (
            <p className="mt-4 text-center text-sm md:mt-3 md:text-base md:whitespace-pre-line">
              {props.data?.description}
            </p>
          )}
          {!!props.data?.data_list?.length && (
            <div className="w-full mt-5 grid grid-cols-1 gap-y-4 md:mt-10 md:grid-cols-2 md:gap-x-10 lg:grid-cols-4">
              {props.data?.data_list?.map((el ,index) => (
                <div
                  key={index}
                  className="flex py-4 rounded-lg md:py-9 md:justify-center max-md:px-5 md:rounded-xl md:duration-300 md:hover:bg-white md:hover:shadow-md max-md:bg-white"
                >
                  <div className="flex md:flex-col md:min-w-[200px] max-md:flex-auto max-md:justify-between max-md:items-end text-center">
                    <span className="text-zinc-600 text-4xl md:text-5xl md:leading-tight">
                      <span className="relative">
                        <CountUp
                          start={0}
                          end={el.value || 0}
                          decimals={getDecimals(el.value || 0)}
                          separator={""}
                          enableScrollSpy
                          scrollSpyOnce
                        />
                        {el.unit && (
                          <span className="absolute -right-1.5 text-xs md:-right-3 md:-top-1 md:text-base">{el.unit}</span>
                        )}
                      </span>
                    </span>
                    <span className="text-zinc-400 text-sm md:mt-2 md:text-base">{el.name}</span>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
